import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import endpoint from 'shared/api';

interface TrackSeedId {
  seedId: string;
}

export const useTrackSeedId = () => {
  const mutation = useMutation({
    mutationFn: ({ seedId }: TrackSeedId) => {
      return endpoint.network.patch(`/signups/seeds/${seedId}/track-click`);
    },
    onError: (error, variables) => {
      const { seedId } = variables;

      Sentry.captureException(error, {
        tags: {
          feature: 'SEED_ID',
        },
        extra: {
          seedId,
          description: `Error happened while tracking a seedId`,
        },
      });
    },
  });

  return mutation;
};
